// В.2.i: Холодильник органов (liv_holodilnik_organov, rare, 0/2/5).
// [Триггер, в начале хода]: возврат случайного юнита из своего сброса в руку.
// Лимит: 3 раза за матч.
//
// Реализация:
//   - Триггер на «начало своего хода» через registerOnStartOfTurnTrigger.
//   - Счётчик использований: card.holodilnikUsesLeft (lazy-init = 3).
//     Хранится прямо на инстансе.
//   - Условия пропуска БЕЗ траты счётчика:
//       1. Счётчик ≤ 0.
//       2. В сбросе нет ни одного юнита.
//       3. Молчание (фильтр в каркасе runOnStartOfTurnTriggers).
//   - При срабатывании:
//       - Случайный юнит из своего сброса (только type='unit').
//       - Извлечь из сброса.
//       - Если рука полная (10 карт) — карта уходит обратно в сброс
//         (сгорает). Счётчик ТРАТИТСЯ (по диздоку).
//       - Иначе: карта добавляется в руку. Счётчик тратится.
//   - Лог зависит от исхода.

import { registerOnStartOfTurnTrigger } from './start-of-turn-triggers.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_holodilnik_organov';
const LABEL = 'Холодильник органов';
const HAND_LIMIT = 10;
const USES_INITIAL = 3;

registerImplementedAbility(CARD_ID, 'trigger');

registerOnStartOfTurnTrigger(CARD_ID, (state, holodilnik, ownerIdx) => {
  const owner = state.players?.[ownerIdx];
  if (!owner) return;
  // Lazy-init счётчика на первом срабатывании.
  if (typeof holodilnik.holodilnikUsesLeft !== 'number') {
    holodilnik.holodilnikUsesLeft = USES_INITIAL;
  }
  if (holodilnik.holodilnikUsesLeft <= 0) return;
  // Кандидаты в сбросе.
  const cands = owner.discard.filter(c => c?.type === 'unit');
  if (cands.length === 0) return;     // нет цели — счётчик не тратим
  // Случайный.
  const dead = cands[state.rng.int(cands.length)];
  const idx = owner.discard.indexOf(dead);
  if (idx === -1) return;
  owner.discard.splice(idx, 1);
  // Сброс «мёртвого» состояния как в воскрешении: карта возвращается в руку
  // как полноценный шаблонный инстанс.
  dead.alive = true;
  dead.line = null;
  dead.slot = null;
  dead.lastLine = null;
  dead.lastSlot = null;
  dead.placedTurn = null;
  dead.revealed = false;
  dead.activated = false;
  dead.heroAttackedThisTurn = false;
  dead.counterAttackedThisPhase = false;
  if (dead.silenceSources) dead.silenceSources.clear();
  if (dead.current) dead.current.silenced = false;
  // current.hp восстанавливаем до base.hp (карта в руке как из колоды).
  if (dead.current) dead.current.hp = dead.base?.hp ?? dead.current.hp;
  if (dead.current) dead.current.armor = dead.base?.armor ?? dead.current.armor;

  holodilnik.holodilnikUsesLeft -= 1;
  const usesLeft = holodilnik.holodilnikUsesLeft;

  if (owner.hand.length >= HAND_LIMIT) {
    owner.discard.push(dead);
    state.log?.add(
      `🧊 ${LABEL} [${owner.name}]: рука полная, "${dead.name_ru}" сгорела (осталось ${usesLeft})`
    );
    return;
  }
  owner.hand.push(dead);
  state.log?.add(
    `🧊 ${LABEL} [${owner.name}]: возврат "${dead.name_ru}" в руку (осталось ${usesLeft})`
  );
});
